<aside class="esf-main-sidebar esf-main-sidebar--working-space -has-transition -is-open -extra-width">
  <div class="esf-main-sidebar__content">
    <h3 i18n='Membership section title@@customerOverviewComponent.modalTitle.editMembership'>Edit membership</h3>
    <form [formGroup]="updateMembershipForm" (ngSubmit)="updateMembershipFormSubmit(updateMembershipForm)" id="updateMembershipForm">
      <div app-form-field-text-generic
           [control]="updateMembershipForm.get('membershipNumber')"
           [placeholder]="flTranslations.i18nMembershipNumber"
           [label]="flTranslations.i18nMembershipNumber">
      </div>
      <div app-form-field-textarea
           [control]="updateMembershipForm.get('comment')"
           [label]="flTranslations.i18nComment"
           [optional]="true"
           [rows]="4">
      </div>
      <div app-form-field-datepicker
           [control]="updateMembershipForm.get('joinDate')"
           [label]="flTranslations.i18nJoinDate"
           [placeholder]="flTranslations.i18nJoinDate">
      </div>
      <div app-form-field-select
           [control]="updateMembershipForm.get('status')"
           [label]="flTranslations.i18nStatus"
           [array]="currentMembership.statuses">
      </div>
    </form>
  </div>
</aside>

<div class="esf-main-sidebar--working-space__actions -has-transition -is-open -extra-width">
  <app-submit-row-buttons [form]="'updateMembershipForm'"
                          [isFieldValid]="customer.isEditable"
                          [cancelButtonText]="buttonsTranslations.i18nBack"
                          [submitButtonText]="buttonsTranslations.i18nSubmit"
                          [spinnerName]="spinnerName"
                          (cancelButton)="customerOverviewService.toggleAllModal(false)">
  </app-submit-row-buttons>
</div>

<div class="esf-hamburger esf-hamburger--working-space  -has-transition -is-open"
     (click)="customerOverviewService.toggleAllModal(false)">
  <span class="esf-hamburger__icon"></span>
</div>
